<template>
    <div class="dts003">
        <CooperationManageHeader :categoryDetail="categoryDetail"/>

        <div class="dts_cnt" v-if="categoryMain">
            <div class="tb-list_ty1">
                <div class="tb-header clear">
                    <div class="tb_num fl">
                        <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalElements})"></div>
                        <!-- 검색 조회시 노출 S -->
                        <div class="check_result" v-show="showSearchCategoryName">
                            <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: rtnSearchCategoryName, cnt: totalElements})"></div>
                            <button type="button" @click="clearSearchCategoryName">초기화</button>
                        </div>
                        <!-- //검색 조회시 노출 E -->
                    </div>  
                    <div class="tb_sort fr">
                      <div class="search_ty2">
                        <button type="button" class="search-show" @click="isSearchArea = true" :class="isSearchArea ? 'active' : ''">검색</button>
                        <form action="" onsubmit="return false;" class="search-show">
                          <div class="input-box">
                              <input type="text" 
                                class="search-show" 
                                :class="searchCategoryName == '' ? 'ico_search' : ''" 
                                :placeholder="$i18nUtil.trans('message.CooperationManager.001','카테고리명 검색')" 
                                @focus="$event.target.placeholder=''"
                                @focusout="$event.target.placeholder=$i18nUtil.trans('message.CooperationManager.001','카테고리명 검색')"
                                maxlength="21"
                                v-model="searchCategoryName" 
                                @keyup.enter="getSearchCategoryList()"
                              />
                              <button type="reset" 
                                class="input-txt-del search-show" 
                                @click="searchCategoryName = ''" 
                                v-if="searchCategoryName != ''"
                              >
                                입력 삭제
                              </button>
                              <button type="reset" 
                                class="btn_search search-show" 
                                @click="getSearchCategoryList()"
                              >
                                검색
                              </button>
                          </div>
                        </form>
                      </div>
                      <CommonFilterHomeB
                        v-if="!isChineseWallUse"
                        :initFilter="initFilter"
                        @updateCommonFilterHomeB="updateCommonFilterHomeB" />
                    </div>
                </div><!-- //tb-header -->

                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="cooperationCategoryListFilter"
                    :page.sync="page"
                    :must-sort="true"
                    :items-per-page="itemsPerPage"  
                    :server-items-length="totalElements"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @page-count="pageCount = $event"
                    hide-default-footer
                    class="tb-contents">

                    <template v-slot:[`item.categoryName`]="{ item }" >
                        <div class="category ell-singleline" @click="moveDetail(item)" style="cursor: pointer; word-break:break-all; display: block;"
                          @mouseover="mouseEvt(true, item, $event)"
                          @mouseleave="mouseEvt(false, item, null)"
                        >
                          {{ item.categoryName }}
                          <div class="tooltip-b tl small" style="display: none; position: absolute; z-index:11;" :id="item.paperId+'_'+item.categoryMid+'_tooptip'">
                              {{ item.categoryName }}
                          </div>
                        </div>
                        <CooperationCategoryMember :item="item" :userId="userId"></CooperationCategoryMember> 
                    </template>

                    <template v-slot:[`item.paperCount`]="{ item }">
                      <CooperationBoardList :item="item" :boardListCount="item.paperCount"></CooperationBoardList> 
                    </template>

                    <template v-slot:[`item.regUserName`]="{ item }"> 
                       <div class="droplayer tooltipmember relative right">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on">
                                      <b>{{ defaultLanguage.indexOf('ko') != -1 ? item.regUserName : item.regUserNameEn != null ? item.regUserNameEn : item.regUserName }}</b>
                                    </v-btn>
                                </template>
                                <div class="dropdown-list">
                                    <UserTooltip
                                      :userId="item.regUserId"
                                    />
                                </div>
                            </v-menu>
                        </div> 
                    </template>

                    <template v-slot:[`item.regDate`]="{ item }"> 
                       {{$moment(item.regDate).format('YYYY.MM.DD') }}
                    </template>

                    <template v-slot:[`item.docGrade`]="{ item }" > 
                       {{item.docGrade == "NORMAL" ? 
                          $i18nUtil.trans("entity.category.docGrade.NORMAL.normal") : $i18nUtil.trans("entity.category.docGrade.RESTRICT","멤버만 공개") 
                        }}
                    </template> 

                    <!-- <template v-slot:item.order="{ item }">
                        <dl class="dl_layer select_ty3">
                            <dt><button type="button" @click="$event.target.parentElement.classList.toggle('active');">
                                {{item.sortNo == null ? 0:item.sortNo}}
                                </button>
                            </dt>
                            <dd style="width:60px">
                                <ul>
                                    <li v-for="idx in cooperationCategoryList.length+1" :key="'sortNo_'+idx">
                                      <button type="button" @click="setSortNo(idx,item)" >{{ idx-1 }}</button>
                                    </li> 
                                </ul>
                            </dd>
                        </dl>
                    </template> -->

                    <!-- <template v-slot:[`item.categoryBookmarkId`]="{ item }">
                        <button type="button" class="ico-switch_favorites small" :class="item.categoryBookmarkId == null ? '' : 'active'"
                                @click="toggleBookmark(item)">즐겨찾기</button>
                    </template> -->

                    <template slot="no-data">
                        <div class="nodata-txt-noicon" v-if="cooperationCategoryListFilter.length == 0 && !showSearchCategoryName">
                            <v-alert :value="true">
                                {{ $i18nUtil.trans("message.CooperationManager.002","참여중인 회의/협의 카테고리가 없습니다.") }}
                            </v-alert>
                        </div>
                        <div class="nodata-txt-noicon" v-if="cooperationCategoryListFilter.length == 0 && showSearchCategoryName">
                            <v-alert :value="true">
                                {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                            </v-alert>
                        </div>
                    </template>
                </v-data-table>

                <div class="pagination">
                    <v-pagination
                    v-model="page"
                    circle
                    :length="pageCount"
                    :total-visible="7"
                    ></v-pagination>
                </div>
            </div><!-- //tb-list_ty1 -->
        </div>

        <CooperationCategoryDetail 
            v-show="categoryDetail" 
            ref="cooperationCategoryDetail"
            :isChineseWallUse="isChineseWallUse"
            @view_Change="changeView" 
            @update_category="updateCategory" 
            @delete_category="deleteCategory"
        ></CooperationCategoryDetail>


        <modals-container
          @regist_category="registCategory"
          @delete_category="deleteCategory"
        ></modals-container>
    </div><!-- //ifs004 -->
</template>

<script>

import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Vue from "vue";
import CooperationManageHeader from "./components/CooperationManageHeader";
import CooperationBoardList from "./components/CooperationBoardList";
import CooperationCategoryMember from "./components/CooperationCategoryMember";
import CooperationCategoryDetail from "./components/CooperationCategoryDetail"; 
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import CommonFilterHomeB from "@/components/cowork/common/filter/CommonFilterHomeB";
export default {
  components: {
      CooperationManageHeader,
      CooperationBoardList,
      CooperationCategoryMember,
      CooperationCategoryDetail, 
      UserTooltip,
      CommonFilterHomeB
  },
  data() {
      return {
          page: 1,
          pageCount: 0,
          itemsPerPage: 20,
          selected: [],
          headers: [
              { text: this.$i18nUtil.trans("entity.category.filter.category","카테고리"), value: 'categoryName', sortable: true},
              { text: this.$i18nUtil.trans("entity.category.filter.paperCount","생성보드 수"), align: 'center', value: 'paperCount', sortable: false },
              { text: this.$i18nUtil.trans("entity.category.filter.docGrade","공개여부"), align: 'center', value: 'docGrade', sortable: false },
              // { text: '노출순서', align: 'center', value: 'order', sortable: false },
              { text: this.$i18nUtil.trans("entity.category.filter.regDate","생성일"), align: 'center', value: 'regDate', sortable: true },
              { text: this.$i18nUtil.trans("entity.category.filter.regUser","생성자"), align: 'center', value: 'regUserName', sortable: false },
              // { text: '즐겨찾기', align: 'center', value: 'categoryBookmarkId', sortable: false },
          ], 

          myInfo:{},
          cooperationCategoryList:[],
          cooperationCategoryListFilter:[],
          userId:"",

          categoryMain:true,
          categoryDetail:false, 

          selectedCategoryDetail:[],

          toastInfo: {
            obj: this.$toasted,
            message: "",
            options: {
              theme: "toasted-primary",
              position: "bottom-left",
              duration: 3000,
            },
          },

          rtnSearchCategoryName:'',
          showSearchCategoryName:false,
          searchCategoryName:'',
          isSearchArea:false,

          /* 정렬 */
          totalElements: 0,
          sortBy: 'regDate',
          sortDesc: true,

          /* 페이지 변경 또는 정렬 이벤트시 */
          changeTableData: false,
          
          isSearch : false,
          gradeCodeList : [],
          initFilter:{},

          //정보차단벽 체크
          isChineseWallUse:false,

          defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
    };
  }, 
  created(){
    this.checkPolicy();
  },
  mounted() {
    const self = this;
    window.onpopstate = function(event) {
      // console.log(this.$router, window.history, "location: " + document.location + ", state: " + JSON.stringify(event.state)); 
      // console.log(event);
      if(self.categoryDetail == true){
        let data = {
          categoryDetail:false,
          categoryMain:true
        }
        self.changeView(data);
      }else{
        let returnUrls = localStorage.getItem("returnUrls");
        if(returnUrls != null) {
          let urlList = returnUrls.split(",");
          if (urlList.length > 0) {
            if (urlList.length == 1) {
              localStorage.removeItem("returnUrls");
              // self.$router.push("/general/home");
            } else {
              urlList.pop();
              localStorage.setItem("returnUrls", urlList);
              // this.$router.replace(urlList[urlList.length-1]);
            }
          } else {
            self.$router.push("/general/home");
          }
        }else{
          self.$router.push("/general/home");
        }
      }
    };
    $("html").click(function (e) {
      if (!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
          self.isSearchArea = false;
      }
    });
    this.getCooperationCategoryListByAuth(false);
  },
  watch:{ 
    page:{
      handler(){
        if(this.changeTableData != true){
          this.changeTableData = true;
        }
          window.scrollTo(0, 0);
          // this.cooperationCategoryListFilter = [];
          // this.cooperationCategoryList = [];
          // this.getCooperationCategoryListByAuth(false);
      }
    },
    sortBy: {
      handler() { 
        if(this.changeTableData != true){ 
          this.changeTableData = true;
        }
          window.scrollTo(0, 0);
          // this.cooperationCategoryListFilter = [];
          // this.cooperationCategoryList = [];
          // this.getCooperationCategoryListByAuth(false);
      }
    },
    sortDesc: {
      handler() { 
        if(this.changeTableData != true){ 
          this.changeTableData = true;
        }
        window.scrollTo(0, 0);
        // this.cooperationCategoryListFilter = [];
        // this.cooperationCategoryList = [];
        // this.getCooperationCategoryListByAuth(false);
      }
    },
    changeTableData:{
      handler(){
        let obj = this;
        if(obj.changeTableData == true){
          setTimeout(() => {
            obj.changeTableData = false;
            // obj.cooperationCategoryListFilter = [];
            // obj.cooperationCategoryList = [];
            obj.getCooperationCategoryListByAuth(this.isSearch);
          }, 500);
        }
      },
      deep: true
    },
  }, 
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
    ...mapActions("modals", ["showToast"]),

    /* 툴팁 */
    mouseEvt(flag, item, event) {
      let tooptipId = item.paperId+'_'+item.categoryMid+'_tooptip';
      if(flag) {
      // 말줄임(...) css 적용 여부 체크 (boolean)
        let val = this.$tooltip.hasOverflownWidthAppendparent(event.target);
        if(val) {
          document.getElementById(tooptipId).style.display = 'block';
        }else{
          document.getElementById(tooptipId).style.display = 'none';
        };
      }else{
        document.getElementById(tooptipId).style.display = 'none';
      }
    },
    // 회의/협의체 권한있는 카테고리 리스트 
    getCooperationCategoryListByAuth(isSearch) {   
      // 회의 협의체 카테고리 관리 sessionStorage 제거
      sessionStorage.removeItem("cooperationManage");
      let obj = this;
      if(isSearch == true) {
        if(obj.searchCategoryName == '') {
          obj.toastInfo.message = obj.$i18nUtil.trans("TB091");//;
          obj.showToast(obj.toastInfo);
          return;
        }
      }
      obj.cooperationCategoryListFilter = [];
      obj.cooperationCategoryList = [];

      if(obj.searchCategoryName != null && obj.searchCategoryName != undefined && obj.searchCategoryName.length > 0) {
        obj.showSearchCategoryName = true;
      } else {
        obj.showSearchCategoryName = false;
      }

      obj.rtnSearchCategoryName = obj.searchCategoryName;

      let reqData = {};
      reqData.params ={
        page : obj.page-1,
        itemsPerPage : obj.itemsPerPage,
        sortKey: obj.sortBy,
        sortDesc: obj.sortDesc,
        searchCategoryName : obj.searchCategoryName,//"%"+ obj.searchCategoryName + "%"
        gradeCodeList: obj.gradeCodeList,
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/cooperation/getCfrcCategoryListPaging";
      reqData.method = "post";
      //프로그레스바 시작 
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {  
          //프로그레스바 종료
          this.hideLoadingbar();  
          obj.pageCount = res.result.categoryList.totalPages;
          obj.totalElements = res.result.categoryList.totalElements;

          obj.cooperationCategoryListFilter = res.result.categoryList.content
          obj.cooperationCategoryList = res.result.categoryList.content; 
          obj.myInfo = res.result.myInfo; 
          obj.userId = res.result.userId;

          this.initFilter = {
            gradeCodeList : this.gradeCodeList
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    //카테고리 추가 
    registCategory(_data){
      
      let obj = this;
      let reqData = {};
      reqData.params ={
          categoryName: _data.categoryName
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/cooperation/insertCfrcCategory";
      reqData.method = "post";
      //프로그레스바 시작 
      this.showLoadingbar();
      obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => { 
            //프로그레스바 종료
            this.hideLoadingbar();
            if(res.errorCode != null){ 
              if (res.errorCode == "NOT_AUTHORIZED"){
                this.showToast(this.toastInfo);
                this.toastInfo.message =  this.$i18nUtil.trans('TB044');
              }
            }else { 
              this.toastInfo.message = this.$i18nUtil.trans('TB076');
              this.showToast(this.toastInfo);
              obj.cooperationCategoryListFilter = [];
              obj.cooperationCategoryList = [];
              obj.searchCategoryName = '';
              obj.rtnSearchCategoryName = '';
              obj.showSearchCategoryName = false;
              obj.getCooperationCategoryListByAuth(false);
            }
          })
          .catch(function(err) {
            console.log(err);
          });
    },
     // 회의/협의체 카테고리 삭제
    deleteCategory(category) {
      let obj = this;
      let reqData = {};
      reqData.params ={
        categoryMid: category.categoryMid,
        siteId: category.sharePointSiteId,
        folderId: category.sharePoinFolderId
      }

      reqData.req = obj.req;
      reqData.url = "/api/copaper/cooperation/deleteCfrcCategory";
      reqData.method = "post";
      //프로그레스바 시작 
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
          //프로그레스바 종료
          this.hideLoadingbar();
          if(res.errorCode != null){ 
            if (res.errorCode == "NOT_AUTHORIZED"){
              this.showToast(this.toastInfo);
              this.toastInfo.message =  this.$i18nUtil.trans('TB044');
            }
          } else {
            this.categoryDetail = false;
            this.categoryMain = true;  
          
            this.toastInfo.message = this.$i18nUtil.trans('TB070');
            this.showToast(this.toastInfo);
            obj.cooperationCategoryListFilter = [];
            obj.cooperationCategoryList = [];
            obj.searchCategoryName = '';
            obj.rtnSearchCategoryName = '';
            obj.showSearchCategoryName = false;
            this.getCooperationCategoryListByAuth(false); 
          }

        })
        .catch(function(err) {
          console.log(err);
        });       
    },
    //회의/협의체 카테고리 수정 
    updateCategory(category, param){
 
      let obj = this;  
      let axiosArr = [];  

      if(this.selectedCategoryDetail.categoryName != category.categoryName || this.selectedCategoryDetail.docGrade != category.docGrade){
        let url = "/api/copaper/cooperation/updateCfrcCategory"
        let data = {
          categoryMid: category.categoryMid,
          categoryName: category.categoryName,
          docGrade : category.docGrade, 
        }
        axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
      }

      if (param != null) { 
        if(param.addManagerUserList.length != 0 ){
          let addManagerUser=[];
          for(let k in param.addManagerUserList){
            let jsonData = {};
            jsonData.userId = param.addManagerUserList[k]; 
            addManagerUser.push(jsonData); 
          } 

          let url = "/api/copaper/cooperation/registCfrcUser"
          let data = {
            addCfrcUserList: addManagerUser, // userId 리스트 
            categoryMid:param.categoryInfo.categoryMid, 
            siteId:param.categoryInfo.sharePointSiteId, 
            folderId:param.categoryInfo.sharePoinFolderId, 
            userGrade:"MANAGER" 
          } 
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }

        if(param.addNormalUserList.length != 0 ){
          let addNormalUser=[];
          for(let k in param.addNormalUserList){
            let jsonData = {};
            jsonData.userId = param.addNormalUserList[k]; 
            addNormalUser.push(jsonData); 
          } 

          let url = "/api/copaper/cooperation/registCfrcUser"
          let data = {
            addCfrcUserList: addNormalUser, // userId 리스트 
            categoryMid:param.categoryInfo.categoryMid, 
            siteId:param.categoryInfo.sharePointSiteId, 
            folderId:param.categoryInfo.sharePoinFolderId, 
            userGrade:"MEMBER" 
          } 
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }

        if(param.deleteManagerUserList.length != 0 ){

          let deleteManagerUser=[];
          for(let k in param.deleteManagerUserList){
            let jsonData = {};
            jsonData.userId = param.deleteManagerUserList[k]; 
            deleteManagerUser.push(jsonData); 
          }
   
          let url = "/api/copaper/cooperation/deleteCfrcUser"
          let data = {
            deleteCfrcUserList: deleteManagerUser, // userId 리스트 
            categoryMid:param.categoryInfo.categoryMid, 
            siteId:param.categoryInfo.sharePointSiteId, 
            folderId:param.categoryInfo.sharePoinFolderId, 
          } 
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }

        if(param.deleteNormalUserList.length != 0 ){
          let deleteNormalUser=[];
          for(let k in param.deleteNormalUserList){
            let jsonData = {};
            jsonData.userId = param.deleteNormalUserList[k]; 
            deleteNormalUser.push(jsonData); 
          }  
          
          let url = "/api/copaper/cooperation/deleteCfrcUser"
          let data = {
            deleteCfrcUserList: deleteNormalUser, // userId 리스트 
            categoryMid:param.categoryInfo.categoryMid, 
            siteId:param.categoryInfo.sharePointSiteId, 
            folderId:param.categoryInfo.sharePoinFolderId, 
          } 
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }

        if(param.updateManagerUserList.length != 0 ){
          let updateManagerUser=[];
          for(let k in param.updateManagerUserList){
            let jsonData = {};
            jsonData.userId = param.updateManagerUserList[k].userId; 
            jsonData.currentUserGrade = param.updateManagerUserList[k].currentUserGrade;
            updateManagerUser.push(jsonData); 
          } 
         
          let url = "/api/copaper/cooperation/updateCfrcUser"
          let data = {
            updateCfrcUserList: updateManagerUser, // userId 리스트 
            categoryMid:param.categoryInfo.categoryMid, 
            siteId:param.categoryInfo.sharePointSiteId, 
            folderId:param.categoryInfo.sharePoinFolderId,
            userGrade : "MANAGER" 
          } 
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }

        if(param.updateNormalUserList.length != 0 ){

          let updateNormalUser=[];
          for(let k in param.updateNormalUserList){
            let jsonData = {};
            jsonData.userId = param.updateNormalUserList[k].userId; 
            jsonData.currentUserGrade = param.updateNormalUserList[k].currentUserGrade;
            updateNormalUser.push(jsonData); 
          } 
          
          let url = "/api/copaper/cooperation/updateCfrcUser"
          let data = {
            updateCfrcUserList: updateNormalUser, // userId 리스트 
            categoryMid:param.categoryInfo.categoryMid, 
            siteId:param.categoryInfo.sharePointSiteId, 
            folderId:param.categoryInfo.sharePoinFolderId,
            userGrade : "MEMBER"
          } 
          axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
        }
      }
  
      if(axiosArr.length > 0) {
        axios.all(axiosArr).then(axios.spread((...responses) => { 
          this.categoryDetail = false;
          this.categoryMain = true;  
          this.cooperationCategoryListFilter = [];
          this.cooperationCategoryList = [];
          this.searchCategoryName = '';
          this.rtnSearchCategoryName = '';
          this.showSearchCategoryName = false;
          this.getCooperationCategoryListByAuth(false); 
          
          let checkPolicyYn = true;
          let checkErrorCode = true;
          let policyBlickUserName = "";
          if(responses.length > 0) {  
            responses.forEach((_res, indx) => {
              
              if(_res.data.errorCode != null){
                checkErrorCode = false;
              }
              // 0312 시점으로 policyBlockUserList에 데이터가 들어올수 없음. (주석처리 되어 있음. );
              if(_res.data.result.policyBlockUserList && _res.data.result.policyBlockUserList.length > 0) {
                _res.data.result.policyBlockUserList.forEach(function(item){
                  policyBlickUserName += item.userName +", ";
                })
                checkPolicyYn = false;
              }
            });
          } 

          if(checkErrorCode){
            if(checkPolicyYn){
              this.toastInfo.message = this.$i18nUtil.trans("message.CooperationManager.003","수정 되었습니다.");
              this.showToast(this.toastInfo); 
            }else{
              this.toastInfo.message = this.$i18nUtil.trans("message.CooperationManage.001","{user}는 정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.", {user: policyBlickUserName.substring(0,policyBlickUserName.length-2)});
              this.showToast(this.toastInfo); 
            }
          }

        })).catch(errors => {});
      }
    },
    moveDetail(item){
      let state = { 
        page:this.page,
        searchCategoryName:this.searchCategoryName,
        sortBy : this.sortBy,
        sortDesc : this.sortDesc,
        gradeCodeList: this.gradeCodeList
      }
      history.pushState(state, document.title, location.href);
      sessionStorage.setItem("cooperationManage",JSON.stringify(state));
      this.categoryDetail = true;
      this.categoryMain = false; 
      let categoryLength = this.cooperationCategoryList.length;
      this.selectedCategoryDetail = item;
      this.$refs.cooperationCategoryDetail.setCategoryInfo(item,this.myInfo,categoryLength);
    },
    changeView(param){ 
      this.cooperationCategoryListFilter = [];
      this.cooperationCategoryList = [];
      this.categoryDetail = param.categoryDetail;
      this.categoryMain = param.categoryMain;
      this.searchCategoryName = '';
      this.rtnSearchCategoryName = '';
      this.showSearchCategoryName = false;    

      let localState = JSON.parse(sessionStorage.getItem("cooperationManage"));
      this.page = localState.page;
      this.sortBy =localState.sortBy;
      this.sortDesc = localState.sortDesc;
      this.gradeCodeList = localState.gradeCodeList; 
      
      if(localState.searchCategoryName != ""){ 
        this.isSearchArea = true;
        this.searchCategoryName = localState.searchCategoryName;
        this.getCooperationCategoryListByAuth(true);
      }else{
        this.getCooperationCategoryListByAuth(false);
      }
    }, 
    toggleBookmark(item){ 
      event.target.classList.toggle('active'); 
      let obj = this;
      let reqData = {};
      reqData.params ={
        categoryMid: item.categoryMid,
        bookmarkId: item.categoryBookmarkId
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/bookmark/saveCategoryBookmark";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
          for(let k in this.cooperationCategoryList){
            if(this.cooperationCategoryList[k].categoryMid == item.categoryMid ){
              this.cooperationCategoryList[k].categoryBookmarkId = res.result;
            }
          }
        }) 
        .catch(function(err) {
          console.log(err);
        });
    },
    clearSearchCategoryName(){
      let obj =this;
      obj.isSearch= false;
      obj.page = 1;
      obj.cooperationCategoryListFilter = [];
      obj.cooperationCategoryList = []; 
      obj.searchCategoryName = '';
      obj.rtnSearchCategoryName = '';
      obj.showSearchCategoryName = false;
      obj.getCooperationCategoryListByAuth(false);
    },
    getSearchCategoryList(){
      this.isSearch=true;
      let obj = this;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    updateCommonFilterHomeB(filterData){
      let obj = this;
      obj.gradeCodeList = filterData.filterGradeList;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    checkPolicy(){
      let obj = this;
      let reqData = {
        url : "/api/org/getCodeValueList",
        method : "post",
        params : {
          cdCategory: 'tenant.env',
          cdKey: 'chinese.wall.use'
        }
      };
      this
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.result[0].cdValue == 'true'){
          // 전체 공개 메뉴 숨김.
          obj.isChineseWallUse = true;
        }
      })
      .catch(function(err) {
          console.log(err);
      });
    }
  }/* methods end */
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/manage/CooperationManage.vue